<template>
  <div class="relative overflow-visible">
    <div
      v-tippy="{ content: title }"
      class="p-2 rounded-full hover:bg-gray-200 w-max cursor-pointer"
      :class="{ 'bg-gray-200': showSubmenu }"
      @click="toggle"
    >
      <SMIcon :icon="icon" />
    </div>
    <Transition
      v-if="$slots.default"
      enter-active-class="transition-opacity duration-300"
      leave-active-class="transition-opacity duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <SMDrawingMenu
        v-show="showSubmenu"
        class="absolute top-1/2 -translate-y-1/3 left-[calc(100%+0.5rem)]"
        @click.stop
      >
        <slot></slot>
      </SMDrawingMenu>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref, inject, Ref, provide, computed, useSlots } from 'vue';
import SMIcon from './SMIcon.vue';
import SMDrawingMenu from './SMDrawingMenu.vue';

const props = defineProps<{
  title: string;
  icon: string;
  active?: boolean;
}>();

const emit = defineEmits<{
  (ev: 'click', event: MouseEvent): void;
}>();

const closeRef = inject<Ref<(() => void) | undefined>>('sm-drawing-menu-close', ref());

const open = (event: MouseEvent) => {
  closeRef.value?.();

  if (!slots.default) {
    emit('click', event);
    closeRef.value = undefined;
  } else {
    closeRef.value = close;
  }
};

const close = () => {
  closeRef.value = undefined;
};

const slots = useSlots();
const toggle = (event: MouseEvent) => {
  if (showSubmenu.value) {
    close();
  } else {
    open(event);
  }
};

const showSubmenu = computed(() => closeRef.value === close || props.active);

provide('sm-drawing-menu-close', ref());
</script>
